import { create } from 'zustand';

export const useBrandingStore = create((set) => ({
  branding: null,
  setBranding: (branding) => set({ branding })
}));


